import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class GenericDropDownFilter extends Component {
    static propTypes = {
        className: PropTypes.string,
        filter: PropTypes.any,
        onChange: PropTypes.func,
        values: PropTypes.array.isRequired,
        shouldHaveAllOption: PropTypes.bool
    };

    static defaultProps = {
        shouldHaveAllOption: true
    };

    constructor(props) {
        super(props);

        this.buildOptions = this.buildOptions.bind(this);
    }

    buildOptions = (values) => {
        let options = [];
        if (this.props.shouldHaveAllOption) {
            options.push(<option key="" value=""></option>);
        }
        _.forEach(values, (value) => {
            options.push(<option key={value} value={value}>{value}</option>);
        });

        return options;
    };

    render() {
        return (
            <select
                className={classNames('filter-input', this.props.className)}
                onChange={(event) => this.props.onChange(event.target.value)}
                value={_.get(this.props, 'filter.value', '')}
            >
                {this.buildOptions(this.props.values)}
            </select>
        );
    }
}
